import { Injectable } from '@angular/core';
import { MaterialDataUpdateService } from 'src/app/services/material-data-update.service';

@Injectable({ providedIn: 'root' })
export class ResponsibleUserService {
  public constructor(private readonly materialDataUpdateService: MaterialDataUpdateService) {}

  public setResponsibleUser(username: string, designId: string) {
    return this.materialDataUpdateService.setResponsibleUser(username, designId);
  }
}
